import useAIJobChannel from 'hooks/useAIJobChannel';
import useInvalidateQueries from 'hooks/useInvalidateQueries';
import AIJob from 'models/AIJob';

type SummaryJobSubscriberProps = {
  job: AIJob;
};

export default function SummaryJobSubscriber({ job }: SummaryJobSubscriberProps) {
  const invalidateQueries = useInvalidateQueries();

  useAIJobChannel({
    params: { ai_job_id: job?.isProcessing ? job.id : undefined },
    onMessageReceived: (data) => {
      if (new AIJob(data).isProcessing) return;

      invalidateQueries({ summarizations: true });
    },
  });

  return null;
}
